import { lazy } from 'react';

export const CourseOverviewPage = lazy(() => import('./CourseOverviewPage'));
